export class GenerateReportDataState {
	public additionalHeaderInfo: string;
}
